import {
  createRouter,
  parseSearchWith,
  RouterProvider,
} from '@tanstack/react-router';
import {routeTree} from 'routeTree.gen';
import {NotFoundPage} from './pages';

// The default search parser JSON-parses every value, so an all-digit id such as
// a deposit accountId (?accountId=9752297707426139) becomes a number. Above
// Number.MAX_SAFE_INTEGER that silently rounds to a different id (...140), so
// such values are kept as the original string instead.
const parseSearch = parseSearchWith((value) => {
  const parsed = JSON.parse(value);
  if (
    typeof parsed === 'number' &&
    /^-?\d+$/.test(value) &&
    !Number.isSafeInteger(parsed)
  ) {
    return value;
  }
  return parsed;
});

const router = createRouter({
  routeTree,
  parseSearch,
  defaultPreload: 'intent',
  defaultStaleTime: 5000,
  scrollRestoration: true,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const AppRouter = () => {
  return (
    <RouterProvider defaultNotFoundComponent={NotFoundPage} router={router} />
  );
};
